import { CalendarOutlined } from '@ant-design/icons-vue';
import ConsultationLevels from '@/views/consultation/ConsultationLevels.vue';
import BookingScheduleManage from '@/views/consultation/BookingScheduleManage.vue';
import BookingParams from '@/views/consultation/BookingParams.vue';
import BookingWindowSettings from '@/views/consultation/BookingWindowSettings.vue';
import ConsultationTicketSettings from '@/views/consultation/ConsultationTicketSettings.vue';
import Consultants from '@/views/consultation/Consultants.vue';
import ConsultantSchedule from '@/views/consultation/ConsultantSchedule.vue';
import ConsultantScheduleEdit from '@/views/consultation/ConsultantScheduleEdit.vue';
import Consultations from '@/views/consultation/Consultations.vue';
import GrowthMemberLinks from '@/views/consultation/GrowthMemberLinks.vue';

export const consultationRoutes = [
    {
        path: 'consultation',
        name: 'ConsultationModule',
        meta: {
            title: '預約諮詢',
            icon: CalendarOutlined
        },
        children: [
            {
                path: 'levels',
                component: ConsultationLevels,
                name: 'ConsultationLevels',
                meta: { title: '等級設置' }
            },
            {
                path: 'booking-rules',
                redirect: { name: 'BookingScheduleManage' },
                meta: { hideInMenu: true }
            },
            {
                path: 'booking-schedule',
                component: BookingScheduleManage,
                name: 'BookingScheduleManage',
                meta: { title: '預約與排班管理' }
            },
            {
                path: 'booking-params',
                component: BookingParams,
                name: 'BookingParams',
                meta: { title: '完整參數設置' }
            },
            {
                path: 'consultation-ticket',
                component: ConsultationTicketSettings,
                name: 'ConsultationTicketSettings',
                meta: { title: '諮詢卷開關' }
            },
            {
                path: 'booking-window',
                component: BookingWindowSettings,
                name: 'BookingWindowSettings',
                meta: { title: '參數設置' }
            },
            {
                path: 'consultants',
                component: Consultants,
                name: 'Consultants',
                meta: { title: '諮詢師管理' }
            },
            {
                path: 'schedule-calendar',
                redirect: { name: 'ConsultantScheduleCalendar' },
                meta: { hideInMenu: true }
            },
            {
                path: 'growth-links',
                component: GrowthMemberLinks,
                name: 'GrowthMemberLinks',
                meta: { title: '世界樹對照' }
            },
            {
                path: 'consultants-compliance',
                name: 'ConsultantsComplianceRedirect',
                redirect: { name: 'Consultants' },
                meta: { hideInMenu: true }
            },
            {
                path: 'consultants/:coreMemberId/schedule',
                component: ConsultantSchedule,
                name: 'ConsultantSchedule',
                // 頁內已有「返回」頂欄，隱藏全域麵包屑＋大標題，避免雙層重疊
                meta: { title: '諮詢師排班', hideInMenu: true, hidePageChrome: true }
            },
            {
                path: 'consultants/:coreMemberId/schedule/edit',
                component: ConsultantScheduleEdit,
                name: 'ConsultantScheduleEdit',
                meta: { title: '代排班表', hideInMenu: true, hidePageChrome: true }
            },
            {
                path: 'bookings',
                component: Consultations,
                name: 'Consultations',
                meta: { title: '預約列表' }
            }
        ]
    }
];
